import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from 'gatsby-image'

function MostPopular({data}) {

  const {area_name, area_name_full} = data

  const images = useStaticQuery(graphql`
      query {
          commusaBatteries: file(relativePath: {eq: "commusa-batteries.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          commusaHeadsets: file(relativePath: {eq: "commusa-headsets.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          commusaRemoteSpeakerMic: file(relativePath: {eq: "commusa-remote-speaker-microphones.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          commusaEarpieceKits: file(relativePath: {eq: "commusa-earpieces-and-surveillance-kits.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          commusaTwoWayChargers: file(relativePath: {eq: "commusa-two-way-radio-chargers.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          commusaAccessories: file(relativePath: {eq: "commusa-other-accessories.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
      }
  `)

  return (
    <div className="container py-3" id="accessories">
      <div className="row">
        <div className="col-12">
          <h3>Most Popular Brands &amp; Models of Two-way Radio Accessories in {area_name}</h3>
          <p>No two-way radio system is complete without the portable and mobile accessories that turn standard
            communications into a system custom-made for your business model. That’s why CommUSA also offers the widest
            selection of portable and mobile two-way radio accessories in {area_name_full}.</p>
          <p>Our large assortment of brands includes Motorola, Pryme, Impact, Klein, Otto Engineering, and David Clark.
            We handpick each of our partners to ensure we’re giving you the most reliable and durable two-way radio
            accessories around. Plus, many of our accessories are certified intrinsically safe, making them ideal for
            even the most hazardous jobs.</p>
          <p>Check out some of our most popular accessories to add to your two-way radio system:</p>
          <div className="row mt-5">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.commusaBatteries.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Batteries"/></div>
            <div className="col-12 col-md-8">
              <h5>Batteries</h5>
              <p>CommUSA has replacement batteries for Motorola two-way radios in {area_name_full}. They’re “Proven
                Tough”
                and are Accelerated Life Testing-approved. Designed to withstand even the harshest conditions, we always
                recommend getting your Motorola two-way radio battery replacement from CommUSA.</p>
              <p>Our top Motorola battery models include the NTN4497DR, PMNN4491B, PMNN4544A, PMNN4077D, PMNN4489D, and
                the PMNN4071AR.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.commusaHeadsets.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Headsets"/></div>
            <div className="col-12 col-md-8">
              <h5>Headsets</h5>
              <p>With a two-way radio headset from CommUSA, you can use your mobile or portable two-way radio
                hands-free. Extend the life of your two-way radio and communicate discreetly with our single muff, dual
                muff, heavy-duty, noise-canceling, hard hat, and behind-the-head two-way radio headsets.&nbsp;<br/></p>

              <p>Browse our best-selling headsets like the RMN4016, HMN9021, and HMN9013.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100"
                                                  fluid={images.commusaRemoteSpeakerMic.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Remote Speaker Microphones"/></div>
            <div className="col-12 col-md-8">
              <h5>Remote Speaker Microphones</h5>
              <p>Your two-way radios are valuable. Keep them safe with two-way radio mics that offer secure and
                hands-free convenience. We carry remote mics, speaker mics, and shoulder mics, including the PMMN4025A,
                PMMN4040A, PMMN4013A, PMMN4071A, and PMMN4050A.<br/></p>

              <p>Don’t forget about your mobile! We have external speakers and loudspeakers for your two-way radio
                mobile plus desktop or telephone-style mobile base microphones for more convenient communications.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100"
                                                  fluid={images.commusaEarpieceKits.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Earpieces and Surveillance Kits"/></div>
            <div className="col-12 col-md-8">
              <h5>Earpieces and Surveillance Kits</h5>
              <p>For those {area_name_full} jobs where discretion is vital, CommUSA carries two-way radio earpieces.
                Check
                out our top earpieces with push-to-talk mics like the PMLN6532A, PMLN5727A, and the PMLN7189A.<br/></p>
              <p>We also carry surveillance kits. Our top sellers include the PMLN6530A, PMLN7157A, PMLN7269A, and the
                PMLN6129A.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.commusaTwoWayChargers.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Chargers"/></div>
            <div className="col-12 col-md-8">
              <h5>Two-Way Radio Chargers</h5>
              <p>With one charging session on our Motorola portable two-way radio chargers, your two-way radio charge
                can last up to three shifts. Browse our single-unit, multi-unit, and bank chargers compatible with most
                Motorola two-way radio models. For example, our PMLN6588A is a 6-bank charger ideal for all your CP
                series portable two-way radios. <br/></p>

              <p>Or browse our IMPRES chargers like the 6-slot PMPN4284A. These chargers utilize a battery
                reconditioning system to keep batteries working better for longer.</p>
              <p>Don’t forget to grab an Uninterrupted Power Supply (UPS)! Our UPS devices will keep your two-way radios
                up and running even during power surges and outages.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 col-md-4"><Img className="w-100" fluid={images.commusaAccessories.childImageSharp.fluid}
                                                  alt="CommUSA - Two-Way Radio Chargers"/></div>
            <div className="col-12 col-md-8">
              <h5>Other Accessories</h5>
              <p>CommUSA also carries nylon and leather carry cases, belt clips, holsters, chest packs, and shoulder
                harness to ensure your portable two-way radio stays safe and close at hand. <br/></p>
              <p>Need an antenna to extend the range of your mobile or base station radio? Ask us about our many
                available antenna options from glass mount, roof mount or high gain-extended range antennas. Or if you
                need an antenna for your portable two-way radio, check out our stubby and whip antenna options.</p>
              <div className="btn-group" role="group">
                <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                  className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                            href="https://www.commusa.com/contact-us">Request
                Quote</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MostPopular
